import { TOPIC_NAMES } from 'crm-message-bus/types/MessageTopics';
export const PREVIEW_OBJECT_HANDLER = {
  topic: TOPIC_NAMES.PREVIEW_OBJECT,
  type: 'MODAL',
  componentLoader: () => import('../wrappers/PreviewObject')
};